var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"video-responsive"}},[_c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.src + '?controls=0&mute=1&playsinline=1&showinfo=0&iv_load_policy=3&rel=0&cc_load_policy=0&autoplay=0&modestbranding=1&disablekb=1&fs=0',"allowFullScreen":"","title":"Embedded youtube"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }